import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as auth from "../../services/auth";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(email.trim());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!emailOk) return;

    setLoading(true);
    try {
      await auth.requestPasswordReset(email.trim());
      setSent(true);
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "No pudimos enviar el correo de recuperación. Intenta nuevamente.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="z-auth-page">
      <div className="z-auth-shell">
        <section className="z-auth-card">
          <div className="z-auth-kicker">Recuperación</div>

          <h1 className="z-auth-title">Recuperar contraseña</h1>

          <p className="z-auth-subtitle">
            Te enviaremos un enlace si el correo existe en nuestra base de datos.
          </p>

          {sent ? (
            <div className="z-auth-alert z-auth-alert--success">
              Si el correo existe en nuestra base de datos, te enviamos un enlace
              para restablecer tu contraseña. Revisa tu bandeja de entrada o spam.
            </div>
          ) : (
            <form className="z-auth-form z-auth-stack" onSubmit={handleSubmit}>
              {error && (
                <div className="z-auth-alert z-auth-alert--error">
                  {error}
                </div>
              )}

              <input
                className="z-auth-input"
                id="fp-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Correo electrónico"
                required
                autoComplete="email"
              />

              {!emailOk && email && (
                <div className="z-auth-note">
                  Ingresa un correo válido, por ejemplo: usuario@dominio.com
                </div>
              )}

              <button
                type="submit"
                disabled={!emailOk || loading}
                className="z-auth-btn"
              >
                {loading ? "Enviando…" : "Enviar enlace"}
              </button>
            </form>
          )}

          <div className="z-auth-help">
            ¿Ya recordaste tu contraseña? <Link to="/login">Inicia sesión</Link>
          </div>
        </section>
      </div>
    </main>
  );
}